import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer23 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const shopLinks = [
        { label: 'Wedding Collection', path: '/template23/shop' },
        { label: 'Festive Edit', path: '/template23/collections' },
        { label: 'Sangeet Outfits', path: '/template23/collections/sangeet' },
        { label: 'Bridal Lehengas', path: '/template23/collections/bridal' },
        { label: 'Men\'s Sherwanis', path: '/template23/collections/sherwanis' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template23/contact' },
        { label: 'Shipping Policy', path: '/template23/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template23/shipping-exchange' },
        { label: 'Size Guide', path: '/template23/size-guide' },
        { label: 'Track Order', path: '/template23/orders' },
    ];

    const occasionLinks = [
        { label: 'Wedding', path: '/template23/shop?occasion=wedding' },
        { label: 'Sangeet', path: '/template23/shop?occasion=sangeet' },
        { label: 'Haldi', path: '/template23/shop?occasion=haldi' },
        { label: 'Diwali', path: '/template23/shop?occasion=diwali' },
        { label: 'Eid', path: '/template23/shop?occasion=eid' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#1B3A2D' }}>
                {/* Gold Decorative Strip */}
                <div style={{ height: '3px', background: 'linear-gradient(90deg, transparent, #C5974B, transparent)' }} />

                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="utsav-footer-main"
                >
                    <div className="utsav-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#C5974B',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                UTSAV
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '14px',
                                    color: '#C5974B',
                                    lineHeight: 1.7,
                                    margin: '0 0 8px 0',
                                    fontStyle: 'italic',
                                    opacity: 0.8,
                                }}
                            >
                                Celebrating Indian Fashion
                            </p>
                            <p
                                style={{
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    color: 'rgba(255,255,255,0.6)',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Curating timeless ethnic wear for every celebration, every occasion, every memory.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[
                                    { icon: <Instagram size={18} />, label: 'Instagram' },
                                    { icon: <Facebook size={18} />, label: 'Facebook' },
                                    {
                                        icon: (
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                            </svg>
                                        ),
                                        label: 'WhatsApp',
                                    },
                                    {
                                        icon: (
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                                <path d="M12 2a10 10 0 1 0 4 19.2" />
                                            </svg>
                                        ),
                                        label: 'Pinterest',
                                    },
                                ].map((social) => (
                                    <a
                                        key={social.label}
                                        href="#"
                                        aria-label={social.label}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid rgba(197, 151, 75, 0.3)',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#C5974B',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#C5974B';
                                            e.currentTarget.style.backgroundColor = 'rgba(197, 151, 75, 0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(197, 151, 75, 0.3)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        {social.icon}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Shop by Occasion */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#C5974B',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Shop by Occasion
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {occasionLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255,255,255,0.7)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C5974B')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.7)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#C5974B',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {shopLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255,255,255,0.7)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C5974B')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.7)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#C5974B',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#C5974B', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: 'rgba(255,255,255,0.7)',
                                        }}
                                    >
                                        hello@utsav.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#C5974B', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: 'rgba(255,255,255,0.7)',
                                        }}
                                    >
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#C5974B"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ flexShrink: 0 }}
                                    >
                                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                    </svg>
                                    <span
                                        style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: 'rgba(255,255,255,0.7)',
                                        }}
                                    >
                                        WhatsApp Us
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#C5974B', flexShrink: 0, marginTop: '2px' }} />
                                    <span
                                        style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: 'rgba(255,255,255,0.7)',
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        Mumbai, Maharashtra, India
                                    </span>
                                </div>
                            </div>

                            {/* Customer Care Links */}
                            <div style={{ marginTop: '24px' }}>
                                <h5
                                    style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '12px',
                                        fontWeight: 700,
                                        color: '#C5974B',
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        margin: '0 0 12px 0',
                                    }}
                                >
                                    Help
                                </h5>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {customerCareLinks.slice(0, 3).map((link) => (
                                        <li key={link.label} style={{ marginBottom: '8px' }}>
                                            <span
                                                onClick={() => navigate(link.path)}
                                                style={{
                                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                    fontSize: '13px',
                                                    color: 'rgba(255,255,255,0.5)',
                                                    cursor: 'pointer',
                                                    transition: 'color 0.3s ease',
                                                    textDecoration: 'none',
                                                }}
                                                onMouseEnter={(e) => (e.target.style.color = '#C5974B')}
                                                onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.5)')}
                                            >
                                                {link.label}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid rgba(197, 151, 75, 0.2)',
                    }}
                >
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '20px 24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '16px',
                            }}
                            className="utsav-footer-bottom"
                        >
                            <p
                                style={{
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '12px',
                                    color: 'rgba(255,255,255,0.4)',
                                    margin: 0,
                                }}
                            >
                                &copy; 2026 UTSAV. All rights reserved.
                            </p>
                            <p
                                style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '12px',
                                    color: '#C5974B',
                                    margin: 0,
                                    fontStyle: 'italic',
                                    opacity: 0.7,
                                }}
                            >
                                Celebrating Indian Fashion
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                {/* Visa */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="3" fill="#234336" stroke="rgba(197,151,75,0.3)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#C5974B" fontSize="8" fontWeight="bold" fontFamily="Nunito Sans, sans-serif">VISA</text>
                                </svg>
                                {/* Mastercard */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="3" fill="#234336" stroke="rgba(197,151,75,0.3)" />
                                    <circle cx="15" cy="12" r="5" fill="#C5974B" opacity="0.4" />
                                    <circle cx="21" cy="12" r="5" fill="#C5974B" opacity="0.4" />
                                </svg>
                                {/* UPI */}
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="3" fill="#234336" stroke="rgba(197,151,75,0.3)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#C5974B" fontSize="7" fontWeight="bold" fontFamily="Nunito Sans, sans-serif">UPI</text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .utsav-footer-grid {
                        display: grid;
                        grid-template-columns: 1.3fr 1fr 1fr 1.3fr;
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .utsav-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .utsav-footer-main {
                            padding: 40px 24px !important;
                        }
                        .utsav-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .utsav-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer23;
